import { useMutation, UseMutationOptions, UseMutationResult, useQuery, UseQueryOptions } from "@tanstack/react-query";
import * as bypassCodeApi from "js/api/bypassCodeApi";

const keyPrefix = "bypassCode";

export const bypassCodeQueryKeys = {
	active: [keyPrefix, "active"] as const,
};

export const useGetActiveBypassCodeQuery = (options?: UseQueryOptions<bypassCodeApi.GetActiveBypassCodeResponse, Error>) => {
	const query = useQuery({
		queryKey: bypassCodeQueryKeys.active,
		queryFn: () => bypassCodeApi.getActiveBypassCode(),
		...options,
	});
	return query;
};

export const useGenerateBypassCodeMutation = (options?: UseMutationOptions<bypassCodeApi.GenerateBypassCodeResponse, Error>) => {
	const mutation = useMutation({
		mutationFn: () => bypassCodeApi.generateBypassCode(),
		...options,
	});
	return mutation;
};

export const useCreateBypassCodeMutation = (
	options?: UseMutationOptions<bypassCodeApi.CreateBypassCodeResponse, unknown, bypassCodeApi.CreateBypassCodeRequest>
): UseMutationResult<bypassCodeApi.CreateBypassCodeResponse, unknown, bypassCodeApi.CreateBypassCodeRequest> => {
	const mutation = useMutation({
		mutationFn: (body: bypassCodeApi.CreateBypassCodeRequest) => bypassCodeApi.createBypassCode(body),
		...options,
	});
	return mutation;
};

export const useUpdateBypassCodeMutation = (
	options?: UseMutationOptions<undefined, unknown, bypassCodeApi.UpdateBypassCodeRequest>
): UseMutationResult<undefined, unknown, bypassCodeApi.UpdateBypassCodeRequest> => {
	const mutation = useMutation({
		mutationFn: (body: bypassCodeApi.UpdateBypassCodeRequest) => bypassCodeApi.updateBypassCode(body),
		...options,
	});
	return mutation;
};
